import React, { useEffect, useState } from 'react'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/client'
import FourOFourPage from 'pageComponents/Error/fourOFourPage'
import Loader from 'pageComponents/_common/loader'
import styled from 'styled-components'
import { Link, useParams } from 'react-router-dom'
import 'style.scss'
import { Helmet } from 'react-helmet'
import BrandTemplate, { rowsToObj } from 'pageComponents/Brands/brandTemplate'
import BrandTemplateTwo from 'pageComponents/Brands/brandTemplateTwo'
import { GET_BRANDEDITOR } from '../../setup/providerGQL'
import { anchorLink } from 'pageComponents/_common/helpers/generalHelperFunctions'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
`

const DivRow = styled.div`
  display: flex;
  justify-content: left;
  margin: 0 auto;
  flex-direction: column;
  max-width: 1300px;
  width: 100%;
  padding: 0 5px;
`

const DivRowHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-item: center;
  text-transform: uppercase;
  font-size: 32px;
  letter-spacing : 2px;
  font-family: verdana;
  color: #333;
  background-image:  linear-gradient( rgba(0,0,0,0),rgba(0,0,0,0.3) ),url(${props => props.url});
  background-size: cover;
  background-position: 50% 0;
  background-repeat: no-repeat;
  background-color: black;
  height: ${props => props.isLargerBanner ? '450px' : '200px'};
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 768px) {
    height: 240px;
    }
  @media (max-width: 400px) {
    height: 190px;
    }
`

const CrumbLink = styled(Link)`
    padding: 0 10px;
    text-transform: capitalize;
    letter-spacing: 1px;
    color:  #246696;
    font-weight: bold;
`
const ShortBorder = styled.div`
    border-bottom: 3px solid #B51F2B;
    width: 80%;
    margin: 15px auto;
    padding: 5px;
`
const CrumbContainer = styled.div`
    font-size: 1rem;
    text-transform: none;
    justify-content: flex-start;
    margin-top: 24px;
`
const Video = styled.video`
    position:relative;
    z-index:0;
	width: 100%;
	object-fit: cover;
    height: ${props => props.isLargerBanner ? '450px' : '200px'};
    @media (max-width: 768px) {
		height: 240px;
	}
	@media (max-width: 400px) {
		height: 190px;
	}
`
const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    object-position: center;

`
const VideoText = styled.h1`
    font-weight: 600;
    font-size: 2.5rem;
    text-align: center;
    text-transform: uppercase;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

`
const Banner = styled.div`

`
const GET_STATIC_PAGE = gql`
    query GetStaticPage($pageId1: String, $pageId2: String, $pageId3: String, $pageId4: String, $hiddenOveride: Boolean){
        getStaticPage(pageId1: $pageId1, pageId2: $pageId2, pageId3: $pageId3, pageId4: $pageId4, hiddenOveride: $hiddenOveride) {
            html
            javascript
            name
            metaTitle
            metaDescription
            mediaUrl
            mediaUrlMedium
            mediaUrlSmall
            hideBanner
            primaryAncestor {
               name
               pageIdPrimary
               pageIdSecondary
               pageIdTertiary
            }
            secondaryAncestor {
              name
              pageIdPrimary
              pageIdSecondary
              pageIdTertiary
            }
            tertiaryAncestor {
                name
                pageIdPrimary
                pageIdSecondary
                pageIdTertiary
            }

        }
    }
`;

function Crumb({ baseUrl, ancestor }) {
    if (ancestor) {
        if (ancestor.pageIdTertiary) {
            return <CrumbLink to={`${baseUrl}/${ancestor.pageIdPrimary}/${ancestor.pageIdSecondary}/${ancestor.pageIdTertiary}`}>{ancestor.name}</CrumbLink>
        } else if (ancestor.pageIdSecondary) {
            return <CrumbLink to={`${baseUrl}/${ancestor.pageIdPrimary}/${ancestor.pageIdSecondary}`}>{ancestor.name}</CrumbLink>
        } else {
            return <CrumbLink to={`${baseUrl}/${ancestor.pageIdPrimary}`}>{ancestor.name}</CrumbLink>
        }
    } else {
        return null
    }
}

function CrumbPage({ primaryAncestor, secondaryAncestor, tertiaryAncestor, baseUrl }) {
    return (
        <>
            <CrumbContainer>
                {primaryAncestor && <> &#9751;<Crumb baseUrl={baseUrl} ancestor={primaryAncestor} /></>}
                {secondaryAncestor && <>&nbsp;&raquo;&nbsp;<Crumb baseUrl={baseUrl} ancestor={secondaryAncestor} /></>}
                {tertiaryAncestor && <>&nbsp;&raquo;&nbsp;<Crumb baseUrl={baseUrl} ancestor={tertiaryAncestor} /></>}
            </CrumbContainer>
        </>
    )
}

const fallbackUrl = "https://airlinemedia.airlinehyd.com/Static_pages/Brands/brands-bg.jpg"

export default function StaticPage(override = {}) {
    const params = useParams()
    const overrides = override.override;
    const pageId1 = (overrides && overrides.pageId1) ? overrides.pageId1 : (params.pageId1)
    const pageId2 = (overrides && overrides.pageId2) ? overrides.pageId2 : (params.pageId2 || null)
    const pageId3 = (overrides && overrides.pageId3) ? overrides.pageId3 : (params.pageId3 || null)
    const pageId4 = (overrides && overrides.pageId4) ? overrides.pageId4 : (params.pageId4 || null)
    const hiddenOveride = (overrides && overrides.pageId1) ? true : false
    const [href, setHref] = useState('');
    const [assignedSource, setAssignedSource] = useState()
    const [pageInfo, setPageInfo] = useState({})
    const [brandsRedirect, setBrandRedirect] = useState({});
    const [template, setTemplate] = useState(0);
    const [url, setUrl] = useState("");

    useEffect(() => {
        //scrollToLink class must be added to Static Page a element
        anchorLink()
    }, [pageInfo])

    useQuery(GET_BRANDEDITOR, {
        fetchPolicy: 'no-cache',
        variables: { urlSlug: pageId2 },
        onCompleted: data => {
            if(pageId1 === "brands"){
                const brandPage = JSON.parse(JSON.stringify(data.getBrandData))
                const brandObj = rowsToObj(brandPage)
                setBrandRedirect(brandObj)
                if (brandObj["template"]) {
                    setTemplate(brandObj["template"])
                } else {
                    console.warn("template key assuming static page")
                    setTemplate(0)
                }
            }
        }

    })

    useEffect(() => {
        // DO NOT REMOVE
        // it forces congrency between the Static Page Obj and the Brand Editor Obj
    }, [brandsRedirect])

    const {
        loading,
        data: {
            getStaticPage = {}
        } = {},
    } = useQuery(GET_STATIC_PAGE, {
        variables: { pageId1, pageId2, pageId3, pageId4, hiddenOveride},
        onCompleted: (res) => {
            console.log('res', res)
            onWindowChange(res.getStaticPage)
            setPageInfo(res.getStaticPage)
            setHref(href); //TODO: update API to include a href option
            // console.log('res.staticpage', res.getStaticPage)
            // console.log('href', href)

        }
    })

    function onWindowChange(pageIn) {
        const internalStaticPage = pageIn || pageInfo
        if (internalStaticPage) {
            const { mediaUrl, mediaUrlMedium, mediaUrlSmall } = internalStaticPage
            const assignedSource = window.innerWidth > 768 ? mediaUrl : window.innerWidth > 400 ? mediaUrlMedium : mediaUrlSmall;
            setAssignedSource(assignedSource)
        }

    }

    useEffect(() => {
        console.log(template)
    }, [template])

    function generateUrl(){
        let tags = [pageId1, pageId2, pageId3, pageId4]
        let temp = `${process.env.REACT_APP_SITE_URL}/pages/`
        tags.forEach((elem) => {
            if(!(
                    elem === "" ||
                    elem === 'null' ||
                    elem === null ||
                    elem === undefined ||
                    elem === 'undefined'
                ))
            {
                temp += `${elem}/`
            }
        })

        return temp;
    }
    useEffect(() => {
        setUrl(generateUrl());
    }, [pageId1, pageId2, pageId3, pageId4])

    const [html, setHtml] = useState("")
    const [js, setJs] = useState("")
    useEffect(() => {
        if (getStaticPage) {
            setHtml(getStaticPage.html);
            setJs(getStaticPage.javascript);
        }
    }, [getStaticPage])

    return (
        <>
            {template == '0'
                && <Container>
                    {!getStaticPage && <FourOFourPage />}
                    {loading && <Loader />}
                    {!loading && getStaticPage && <>
                        <Helmet>
                            <title>{getStaticPage.metaTitle || 'Airline Hydraulics'}</title>
                            <meta name="description" content={getStaticPage.metaDescription || 'Airline Hydraulics Corporation'} />

                            <link rel="canonical" href={url?.slice(0, -1)} />
                            {getStaticPage.html.search("recruitment-current-openings") !== -1 && <script src='https://workforcenow.adp.com/mascsr/default/mdf/recwebcomponents/recruitment/main-config/recruitment.js'></script>}

                            {getStaticPage.html.search("cincopa") !== -1 && <script>{`
                                var setupCincopaGallery = (galleryId, fid) => {
                                    /*
                                    * Generates an asynchronous script tag with an external script source and
                                    * programatically adds it to the static page. The external script gets executed when
                                    * it fully loads .
                                    */
                                    var cp = document.createElement("script");
                                    cp.type = "text/javascript";
                                    cp.async = true;
                                    cp.src = "//www.cincopa.com/media-platform/runtime/libasync.js";
                                    var c = document.getElementById(galleryId);
                                    c.parentNode.insertBefore(cp, c);

                                    /*
                                    * We have to wait a small amount of time for the injected async script tag to load
                                    * before we can initialize the gallery.
                                    *
                                    * This is bad practice because it could take longer than the below wait time for the
                                    * external script to load, which would cause the following code to throw an error, breaking
                                    * the page.
                                    */
                                    setTimeout(() => {
                                        var cpo = [];
                                        cpo["_object"] = galleryId;
                                        cpo["_fid"] = fid;

                                        _cpmp = _cpmp || []
                                        _cpmp.push(cpo);

                                        /*
                                        * This is an artifact from the external script from Cincopa. It activates Cincopa galleries\
                                        * represented by the contents of the above array.
                                        */
                                        cincopa.boot_all()

                                    }, 1500);
                                }
                            `}</script>}
                            {getStaticPage.javascript && (
                                <script type="text/javascript">
                                    {js}
                                </script>
                            )}
                        </Helmet>

                        {!pageInfo?.hideBanner ? (

                            <Banner>
                                {(assignedSource?.includes(".mp4")) ? //expand extensions as required with an OR
                                    (<>
                                        <VideoContainer>
                                            <VideoText>
                                                {getStaticPage.name}
                                                <ShortBorder />
                                            </VideoText>
                                            <Video isLargerBanner={!!assignedSource} src={assignedSource} autoPlay loop muted></Video>
                                        </VideoContainer>
                                    </>)
                                    :
                                    (<VideoContainer >
                                        <VideoText>
                                            {getStaticPage.name}
                                            <ShortBorder />
                                        </VideoText>
                                        <DivRowHeader url={assignedSource || fallbackUrl} isLargerBanner={!!assignedSource}></DivRowHeader>
                                    </VideoContainer>)
                                }
                            </Banner>
                        )
                            :
                            null
                        }
                        <DivRow>
                            <CrumbPage {...getStaticPage} baseUrl='/pages' />
                        </DivRow>

                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    </>}
                </Container>}
            {template == '1' && <BrandTemplate brandEditor={brandsRedirect} />}
            {template == '2' && <BrandTemplateTwo brandEditor={brandsRedirect} />}
        </>
    )
}
